module.exports = __webpack_public_path__ + "img/Shiba-BG.c68d58c8.jpg";